module.exports = __webpack_public_path__ + "img/Support-skill-302.549b3508.png";